// @flow

import type {
  EmployeeEventsState,
  SpecificDocumentType,
} from "@modules/shared/reducer/employee-events/types";
import type { PaginatedList } from "@types";
import { startRequest, finishRequest } from "@store/utils";
import { defaultEventHistory } from "./state";

export const setLoading = (state: EmployeeEventsState) => () => startRequest(state);

export const setLoaded = (state: EmployeeEventsState) => () => finishRequest(state);

export const onGetEmployeeDocumentsSuccess = (state: EmployeeEventsState) => ({
  payload,
}: Object) => ({
  ...finishRequest(state),
  error: null,
  documents: payload,
});

export const onGetEmployeeDocumentsError = (state: EmployeeEventsState) => ({
  payload,
}: Object) => ({
  ...finishRequest(state),
  error: payload,
  documents: {
    ...state.documents,
    content: [],
  },
});

export const onGetEmployeeSpecificDocumentsSuccess = (state: EmployeeEventsState) => ({
  payload,
}: $Exact<{
  payload: PaginatedList<SpecificDocumentType>,
}>) => {
  return {
    ...state,
    specificDocuments: payload,
  };
};

export const onToggleRemoveEmployeeDocumentModal = (state: EmployeeEventsState) => ({
  payload,
}: $Exact<{
  action: string,
  payload: $Exact<{
    visible: boolean,
    documentId: number,
    documentName: string,
  }>,
}>) => ({
  ...state,
  modals: {
    ...state.modals,
    removeDocument: {
      ...state.modals.removeDocument,
      visible: payload.visible,
      documentId: payload.documentId,
      documentName: payload.documentName,
    },
  },
});

export const onRemoveEmployeeDocumentError = (state: EmployeeEventsState) => ({
  payload,
}: Object) => ({
  ...state,
  error: payload,
  modals: {
    ...state.modals,
    removeDocument: {
      ...state.modals.removeDocument,
      visible: false,
      documentId: null,
      documentName: null,
    },
  },
});

export const onToggleAddEmployeeDocumentModal = (state: EmployeeEventsState) => ({
  payload,
}: Object) => ({
  ...state,
  modals: {
    ...state.modals,
    addDocument: {
      ...state.modals.addDocument,
      visible: payload,
    },
  },
});

export const onAddEmployeeDocumentError = (state: EmployeeEventsState) => ({
  payload,
}: Object) => ({
  ...finishRequest(state),
  error: payload,
  modals: {
    ...state.modals,
    addDocument: {
      ...state.modals.addDocument,
      visible: false,
    },
  },
});

export const onGetEmployeeEventHistory = (state: EmployeeEventsState) => () => {
  return {
    ...state,
    requestsInProgress: ++state.requestsInProgress,
  };
};

export const onGetEmployeeEventHistorySuccess = (state: EmployeeEventsState) => ({
  payload,
}: Object) => {
  return {
    ...finishRequest(state),
    eventHistory: { ...state.eventHistory, [payload.taskType]: payload.data },
  };
};
export const onResetEmployeeEventHistory = (state: EmployeeEventsState) => ({
  payload,
}: Object) => {
  return {
    ...state,
    eventHistory: defaultEventHistory,
  };
};
export const onGetEmployeeEventHistoryError = (state: EmployeeEventsState) => ({
  payload,
}: Object) => {
  const response = {
    ...finishRequest(state),
    eventHistory: { ...state.eventHistory },
    error: payload,
  };
  return response;
};

export const onGetManualReferralEnabledSuccess = (state: EmployeeEventsState) => ({
  payload,
}: Object) => {
  return {
    ...state,
    isManualReferralAvailable: payload.isManualReferralAvailable,
    isEmployeeEligible: payload.isEmployeeEligible,
  };
};
export const onGetReferralProcessesSuccess = (state: EmployeeEventsState) => ({
  payload,
}: Object) => {
  return {
    ...state,
    modals: {
      ...state.modals,
      manualReferral: {
        ...state.modals.manualReferral,
        processes: payload,
      },
    },
  };
};

export const onToggleManualReferralModal = (state: EmployeeEventsState) => () => {
  return {
    ...state,
    modals: {
      ...state.modals,

      manualReferral: {
        ...state.modals.manualReferral,
        visible: !state.modals.manualReferral.visible,
      },
    },
  };
};

export const onToggleEventHistoryItemModal = (state: EmployeeEventsState) => ({
  payload,
}: Object) => ({
  ...state,
  modals: {
    ...state.modals,
    eventHistoryItem: {
      ...state.modals.eventHistoryItem,
      visible: payload,
    },
  },
});

export const onToggleAbsenceReviewModal = (state: EmployeeEventsState) => ({
  payload,
}: Object) => ({
  ...state,
  modals: {
    ...state.modals,
    absenceReviewItem: {
      ...state.modals.absenceReviewItem,
      visible: payload,
    },
  },
});

export const onToggleReferralDecisionModal = (state: EmployeeEventsState) => () => {
  return {
    ...state,
    modals: {
      ...state.modals,
      referralDecisionModal: {
        ...state.modals.referralDecisionModal,
        visible: !state.modals.referralDecisionModal.visible,
      },
    },
  };
};

export const onGetManualReferralTaskDataSuccess = (state: EmployeeEventsState) => ({
  payload,
}: Object) => {
  return {
    ...state,
    modals: {
      ...state.modals,
      manualReferralTaskDataModal: {
        ...state.modals.manualReferralTaskDataModal,
        taskData: payload,
      },
    },
  };
};
export const onToggleManualReferralTaskDataModal = (state: EmployeeEventsState) => () => {
  return {
    ...state,
    modals: {
      ...state.modals,
      manualReferralTaskDataModal: {
        ...state.modals.manualReferralTaskDataModal,
        visible: !state.modals.manualReferralTaskDataModal.visible,
      },
    },
  };
};
